import styled from 'styled-components'
import { SIZES } from '../../../constants'

const ImageCol = styled.div`
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    margin-bottom: 15px;
    width: 100%;
  }
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    width: 235px;
  }
`

const ListCol = styled.div`
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    width: 100%;
  }
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    width: calc(100% - 235px);
  }
  @media (min-width: ${SIZES.BREAKPOINT_MD}px) {
    padding-right: 15px;
  }
`

export { ImageCol, ListCol }
